export default "__VITE_ASSET__DkarUH82__"